export const loadPaymentProviderScript = (url: string, onLoad: () => void) => {
  const script = document.createElement('script');
  script.src = url;
  document.body.appendChild(script);

  script.onload = () => onLoad();
};
